import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Calcagro.css";
import logo from "../../assets/calcagro.png"; // Substitua pelo caminho da logo
import img1 from "../../assets/agro1.jpg"; // Imagem 1 - plantação
import img2 from "../../assets/agro2.jpg"; // Imagem 2 - colheita
import img3 from "../../assets/agro3.jpg"; // Imagem 3 - produtividade
import img4 from "../../assets/agro4.jpg"; // Imagem 4 - gestão
import img5 from "../../assets/agro5.jpg"; // Imagem 5 - análise

const CalcAgro = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    adaptiveHeight: true
  };

  const advantages = [
    {
      title: "Produção e Produtividade",
      content: "A produtividade refere-se à quantidade de kg produzidos por hectare em um período específico. Esse valor é essencial para avaliar a eficiência da operação. A produtividade é um indicador-chave para medir se você está utilizando a tecnologia adequada e a eficiência com que ela é aplicada.",
      image: img3
    },
    {
      title: "Custo do Capital e Depreciação",
      content: "Mede o retorno financeiro do capital investido em benfeitorias, máquinas, equipamentos e formação da cultura. Esse capital, se aplicado no mercado financeiro, poderia gerar retorno. A depreciação calcula a perda de valor do capital investido ao longo do tempo.",
      image: img4
    },
    {
      title: "Custos Operacionais",
      content: "Incluem todas as despesas necessárias para manter a produção de culturas, temporárias ou permanentes, como mão de obra, manutenção, fertilizantes e despesas financeiras. Controlar esses custos é essencial para garantir a lucratividade do negócio.",
      image: img5
    },
    {
      title: "Receita e Rentabilidade",
      content: "Refere-se ao total gerado pela venda da produção (preço por unidade x quantidade vendida). A receita é um indicador fundamental da saúde financeira do negócio, devendo ser suficiente para cobrir os custos operacionais e totais, além de gerar lucro.",
      image: img1
    },
    {
      title: "Relatório Final",
      content: "Oferece uma visão integrada dos resultados calculados ou simulados, facilitando a tomada de decisões estratégicas. Essa ferramenta é vital para monitorar o desempenho continuamente, aumentando a eficiência na gestão e economizando tempo e recursos.",
      image: img2
    }
  ];

  const plans = [
    {
      name: "Mensal",
      price: "R$19,90/mês",
      features: [
        "Cálculos ilimitados",
        "Simulações ilimitadas",
        "Suporte disponível",
        "Pagamento mensal"
      ]
    },
    {
      name: "Trimestral",
      price: "R$49,90/trimestre",
      features: [
        "Cálculos ilimitados",
        "Simulações ilimitadas",
        "Suporte disponível",
        "Pagamento a cada três meses"
      ]
    },
    {
      name: "Anual",
      price: "R$199,90/ano",
      features: [
        "Cálculos ilimitados",
        "Simulações ilimitadas",
        "Suporte disponível",
        "Pagamento anual"
      ]
    }
  ];

  return (
    <div className="calcagro-page-container">
      <header className="calcagro-page-header">
        <div className="calcagro-logo-container">
          <img src={logo} alt="CalcAgro Logo" className="calcagro-page-logo" />
        </div>
        <h1 className="calcagro-title">CalcAgro</h1>
        <p className="calcagro-header-subtitle">
          Com o CalcAgro você obterá independência e autonomia quando se trata das economias e finanças do seu negócio, de maneira rápida, simples, segura e eficaz.
        </p>
      </header>

      <section className="calcagro-hero-section">
        <Slider {...sliderSettings} className="calcagro-image-slider">
          <div className="calcagro-slide">
            <img src={img1} alt="Controle de Custos" />
            <div className="calcagro-slide-caption">
              <h3>Controle de Custos</h3>
              <p>Monitoramento detalhado de despesas para otimizar recursos e maximizar lucros</p>
            </div>
          </div>
          <div className="calcagro-slide">
            <img src={img2} alt="Análise de Desempenho" />
            <div className="calcagro-slide-caption">
              <h3>Análise de Desempenho</h3>
              <p>Visão abrangente sobre o estado financeiro do seu negócio agrícola</p>
            </div>
          </div>
        </Slider>
      </section>

      <section className="calcagro-features-section">
        <div className="calcagro-feature-card">
          <div className="calcagro-feature-content">
            <h3>Sobre o App</h3>
            <p>
              O sistema oferece controle detalhado dos custos, monitorando despesas com culturas permanentes, temporárias, milho, sorgo, e outras. Auxilia no planejamento financeiro ao criar orçamentos e estratégias, otimizando o uso de recursos e maximizando os lucros nas diversas atividades agrícolas.
            </p>
          </div>
        </div>
        <div className="calcagro-feature-card">
          <div className="calcagro-feature-content">
            <h3>E mais...</h3>
            <p>
              A análise de desempenho proporciona uma visão abrangente sobre o estado financeiro do negócio, identificando áreas de lucro e oportunidades de melhoria. Com foco em transparência, o sistema possibilita que todos os envolvidos acessem informações financeiras atualizadas, fortalecendo a confiança e promovendo uma colaboração eficaz no ambiente de trabalho.
            </p>
          </div>
        </div>
      </section>

      <section className="calcagro-plans-section">
        <h2 className="calcagro-section-title">Confira nossos planos</h2>
        <div className="calcagro-plans-grid">
          {plans.map((plan, index) => (
            <div className="calcagro-plan-card" key={index}>
              <div className="calcagro-plan-header">
                <h3>{plan.name}</h3>
                <p className="calcagro-plan-price">{plan.price}</p>
              </div>
              <ul className="calcagro-plan-features">
                {plan.features.map((feature, i) => (
                  <li key={i}>{feature}</li>
                ))}
              </ul>
              <Link to="/login" className="calcagro-plan-button">Assinar</Link>
            </div>
          ))}
        </div>
      </section>

      <section className="calcagro-advantages-section">
        <h2 className="calcagro-section-title">Vantagens de obter o CalcAgro</h2>
        <div className="calcagro-advantages-grid">
          {advantages.map((advantage, index) => (
            <div className="calcagro-advantage-card" key={index}>
              <div className="calcagro-advantage-image">
                <img src={advantage.image} alt={advantage.title} />
              </div>
              <div className="calcagro-advantage-content">
                <h3>{advantage.title}</h3>
                <p>{advantage.content}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <div className="calcagro-cta-container">
        <Link to="/login" className="calcagro-cta-button">Comece agora</Link>
        <Link to="/" className="calcagro-back-link">Voltar para Home</Link>
      </div>
    </div>
  );
};

export default CalcAgro;